export default {
  strict: true,
  namespaced: true,
  state: {
    asapRequest: {
      show: false,
      data: '',
      customer: ''
    }
  },
  mutations: {
    setAsapModal (state, value) { state.asapRequest.show = value },
    setAsapData (state, value) { state.asapRequest.data = value },
    setAsapCustomer (state, value) { state.asapRequest.customer = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation-details/asap.js